import React, { useEffect, useState } from "react";
import "./index.css";
import { AmbikaVenderApi } from "../config";
import axios from "axios";
import StatusModal from "./StatusModal";
import RouteCard from "./RouteCard";
import CustomerCard from "./CustomerCard";
import { FaSync } from "react-icons/fa"; // Import refresh icon
import { db } from "../../firebase"; // Import Firebase database
import { ref, onValue } from "firebase/database";
import { useProfile } from "../ProfileContext";

const staticStatusCodes = [
  {
    id: 1,
    code: "U",
    name: "Order Placed with Urgent (U)",
    color_code: "#FF6969",
  },
  {
    id: 2,
    code: "P",
    name: "Order Placed with Packing (P)",
    color_code: "#FF6969",
  },
  { id: 3, code: "O", name: "Order Placed with O", color_code: "#FF6969" },
  {
    id: 4,
    code: "Z",
    name: "Order with Placed with Partially Ready (Z)",
    color_code: "#FF6969",
  },
];

const Dashboard = () => {
  const [routeWiseProduct, setRouteWiseProduct] = useState([]);
  const [customerOrderProduct, setCustomerOrderProduct] = useState([]);
  const [productStatusCode, setProductStatusCode] = useState();
  const [showColorCodeModal, setShowColorCodeModal] = useState(false);
  const [isRefreshing, setIsRefreshing] = useState(false);
  const ambikaUserToken = localStorage.getItem("ambikaUserToken");
  const ambikaUserId = localStorage.getItem("ambikaUserId");
  const { profileData } = useProfile();

  const getRoutewiseProduct = () => {
    return axios
      .post(
        `${AmbikaVenderApi}/vendor/vendorRoutewiseProduct`,
        { UserId: ambikaUserId },
        { headers: { Authorization: `Bearer ${ambikaUserToken}` } }
      )
      .then((res) => {
        setRouteWiseProduct(res?.data?.data || []);
      });
  };

  const getCustomerOrderProductList = () => {
    return axios
      .post(
        `${AmbikaVenderApi}/vendor/customerOrderProductList`,
        { UserId: ambikaUserId },
        { headers: { Authorization: `Bearer ${ambikaUserToken}` } }
      )
      .then((res) => {
        setCustomerOrderProduct(res?.data?.data);
      });
  };

  const getProductStatusCode = () => {
    return axios
      .get(`${AmbikaVenderApi}/vendor/productStatusCode`, {
        headers: { Authorization: `Bearer ${ambikaUserToken}` },
      })
      .then((res) => {
        setProductStatusCode(res?.data?.data);
      });
  };

  const refreshAllData = () => {
    setIsRefreshing(true);
    Promise.all([
      getRoutewiseProduct(),
      getCustomerOrderProductList(),
      getProductStatusCode(),
    ])
      .catch((err) => {
        console.error("Error refreshing data:", err);
      })
      .finally(() => {
        setIsRefreshing(false);
      });
  };

  useEffect(() => {
    refreshAllData();
  }, []);

  useEffect(() => {
    const statusRef = ref(db, `orders/${profileData.branchId}`);
    const unsubscribe = onValue(statusRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        refreshAllData();
        console.log("Updated order status from Firebase", data);
      }
    });

    return () => unsubscribe();
  }, [profileData.branchId]);

  return (
    <div className="container py-4">
      <div className="dashboard-header">
        <h5 className="text-muted">Dashboard</h5>
      </div>

      <StatusModal
        show={showColorCodeModal}
        onClose={() => setShowColorCodeModal(false)}
        productStatusCode={productStatusCode}
      />

      <div className="row mb-4 gy-3">
        {routeWiseProduct?.length > 0 ? (
          routeWiseProduct.map((route) => (
            <RouteCard
              key={route.route_id}
              route={route}
              onInfoClick={() => setShowColorCodeModal(true)}
              productStatusCode={productStatusCode}
              staticStatusCodes={staticStatusCodes}
            />
          ))
        ) : (
          <div className="col-12">
            <div className="alert alert-info">No route data available</div>
          </div>
        )}
      </div>

      <div className="row gy-3 mb-4">
        {customerOrderProduct?.map((custId, idx) => (
          <CustomerCard
            key={`${custId}-${idx}`}
            details={custId}
            onInfoClick={() => setShowColorCodeModal(true)}
            refreshAllData={refreshAllData}
            productStatusCode={productStatusCode}
            staticStatusCodes={staticStatusCodes}
          />
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
